export default {
  index: [
    {
      path: '/InvoiceForm',
      component: resolve => require(['./InvoiceIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/InvoiceForm/_router.js